export default "__VITE_ASSET__BBKMflCE__"